var jade = require("/opt/actions-runner/_work/DI-Plan-Go-web/DI-Plan-Go-web/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

var jade_indent = [];
buf.push("\n<div ng-if=\"customer.imageUrl\">\n  <spinner></spinner><img ng-src=\"{{ imageUrl(customer) }}\" width=\"{{ 540 }}\">\n</div>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/html/templates/viewImageTemplate.jade
 ** module id = 111
 ** module chunks = 1
 **/